// @ts-nocheck
import * as Types from '../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
export type OptionCombinationsChip_TakeoffLineItemFragment = { __typename?: 'TakeoffLineItem', id: string, placeholder?: { __typename?: 'TakeoffLineItem', id: string, targetGroups: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string, name: string, order: number }> } | null | undefined, targetGroups: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string, name: string, order: number }>, targetCombinations: Array<{ __typename?: 'DesignPackageOptionCombination', id: string, name: string, options: Array<{ __typename?: 'ReadyPlanOption', id: string }> }>, missingCombinations: Array<{ __typename?: 'DesignPackageOptionCombination', id: string, name: string }> };

export type OptionCombinationsChip_TakeoffLineItem_TargetGroupFragment = { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, order: number };

export const OptionCombinationsChip_TakeoffLineItem_TargetGroupFragmentDoc = gql`
    fragment OptionCombinationsChip_TakeoffLineItem_TargetGroup on ReadyPlanOptionGroup {
  id
  name
  order
}
    `;
export const OptionCombinationsChip_TakeoffLineItemFragmentDoc = gql`
    fragment OptionCombinationsChip_TakeoffLineItem on TakeoffLineItem {
  id
  placeholder {
    id
    targetGroups {
      ...OptionCombinationsChip_TakeoffLineItem_TargetGroup
    }
  }
  targetGroups {
    ...OptionCombinationsChip_TakeoffLineItem_TargetGroup
  }
  targetCombinations {
    id
    name
    options {
      id
    }
  }
  missingCombinations {
    id
    name
  }
}
    ${OptionCombinationsChip_TakeoffLineItem_TargetGroupFragmentDoc}`;